import React, { Component } from 'react';
import {
  withStyles,
  Grid,
  Button, TextField,
  FormControl, 
  InputLabel, Select,
  MenuItem,
  LinearProgress
} from '@material-ui/core';
import * as moment from 'moment';
import styles from './styles/FilterStyles';
import problemsTypesMap from '../../commons/ProblemsTypesMap';
import DatePickerModal from '../../commons/components/DatePickerModal';
import AutoComplete from '../../commons/components/AutoComplete';

const ALL_PROBLEMS = Object.keys(problemsTypesMap);

class Filter extends Component {
  state = {
    serial: '',
    vehicleCode: '',
    problemsTypes: ALL_PROBLEMS,
    customer: null,
    dateStart: null,
    dateEnd: null,
    modalOpen: false
  };

  updateFilter = () => {
    const filter = { ...this.getFilterData() };
    this.props.updateFilter(filter);
  }

  componentDidMount() {
    this.setState({ ...this.props.filter });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps.filter });
  }

  getFilterData = () => {
    const { serial, vehicleCode } = this.state;
    const customer = this.state.customer || this.props.filter.options.customers[0];
    const dateStart = this.state.dateStart || moment(new Date()).format('YYYY-MM-DD');
    const dateEnd = this.state.dateEnd || moment(new Date()).format('YYYY-MM-DD');
    const problemsTypes = this.state.problemsTypes || ALL_PROBLEMS;
    return { ...this.props.filter, serial, vehicleCode, customer, dateStart, dateEnd, problemsTypes };
  }

  updateCustomer = event => {
    this.props.updateCustomer(event.target.value);
  }

  render() {
    const { classes, loading } = this.props;
    const { serial, vehicleCode, problemsTypes, customer, dateStart, dateEnd } = this.getFilterData();

    let selectOptions;
    if (this.props.filter.options.organizationsNames) {
      selectOptions = this.props.filter.options.organizationsNames.map(suggestion => ({
        value: suggestion,
        label: suggestion,
      }));
    }

    const selectedOptions = this.props.filter.organizationsNames;

    return (
      <form autoComplete="off" style={{marginBottom: 30}}>
        <Grid className={classes.root}>
          <Grid container spacing={24}>
            <Grid item xs={4}>
              <TextField
                id="serial"
                label="Serial"
                value={serial || ''}
                className={classes.textField}
                onChange={(event) => this.setState({ serial: event.target.value })}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="vehicleCode"
                label="Código do Veículo"
                value={vehicleCode || ''}
                className={classes.textField}
                onChange={(event) => this.setState({ vehicleCode: event.target.value })}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="date"
                label="Período"
                value={`${dateStart.split('-').reverse().join('/')} a ${dateEnd.split('-').reverse().join('/')}`}
                onClick={() => this.setState({ modalOpen: true })}
                onChange={() => {}}
                className={classes.dateGridPadding}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="customer">Cliente</InputLabel>
                <Select
                  value={customer || ''}
                  onChange={this.updateCustomer}
                  inputProps={{
                    name: 'customers',
                    id: 'customer',
                  }}
                >
                  {this.props.filter.options.customers
                  && this.props.filter.options.customers.map((customer, key) => 
                    <MenuItem key={key} value={customer}>{customer}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={5}>
              <FormControl className={classes.organizationSelect}>
                <AutoComplete
                  isMulti={true}
                  placeholder="Organizações"
                  options={selectOptions}
                  selectedOptions={selectedOptions}
                  selectOption={this.props.updateOrganizationsNames}
                />
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="problemsId">Tipos de Problema</InputLabel>
                <Select
                  value={problemsTypes}
                  onChange={(event) => this.setState({ problemsTypes: event.target.value })}
                  inputProps={{
                    name: 'problems',
                    id: 'problemsId',
                  }}
                >
                  <MenuItem value={problemsTypes} disabled>
                    {!(problemsTypes.length > 1) && problemsTypes !== ALL_PROBLEMS ? problemsTypesMap[problemsTypes[0]] : 'Qualquer'}
                  </MenuItem>
                  <MenuItem value={ALL_PROBLEMS}>Qualquer</MenuItem>
                  {this.props.filter.options.problemsTypes 
                  && this.props.filter.options.problemsTypes.map((problemType, key) =>
                    <MenuItem key={key} value={problemType}>{problemsTypesMap[problemType[0]]}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} className={classes.actions}>
              <Button onClick={this.props.cleanFilter}>Limpar Filtro</Button>
              <Button color="primary" onClick={this.updateFilter}>Aplicar Filtro</Button>
            </Grid>
          </Grid>
        </Grid>
        {loading && <div style={{flexGrow: 1}}>
          <LinearProgress style={{marginLeft: 30, marginRight: 30}} />
        </div>}
        <DatePickerModal
          open={this.state.modalOpen}
          start={this.getCorrectDate(dateStart)}
          end={this.getCorrectDate(dateEnd)}
          onClose={this.onClose}
          updatePeriod={this.updatePeriod}
        />
      </form>
    );
  }

  getCorrectDate = (date) => {
    const correctDate = new Date(date);
    correctDate.setDate(correctDate.getDate() + 1);
    return correctDate;
  }

  onClose = () => {
    this.setState({ modalOpen: false });
  }

  updatePeriod = (start, end) => {
    this.setState({
      dateStart: start.toISOString().substr(0, 10),
      dateEnd: end.toISOString().substr(0, 10)
    });
  }
}

export default withStyles(styles)(Filter);


// WEBPACK FOOTER //
// ./src/main/components/Filter.jsx